import React from 'react';
import { call } from 'redux-saga/effects';

import { imgPath } from '~common/utilities/ImgUrl';
import { getWorkbookInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import {
  ContentTypeFilterClause,
  MixedContentItemDefinition,
  SpaceDefinition
} from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { WorkbookContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { WorkbookCard } from '~src/workbook/components/contentDefinitions/WorkbookCard';
import { ConnectedWorkbookDetailsDialogBody } from '~src/workbook/components/WorkbookDetailsDialog';
import { IWorkbookDetailInfoWithUsage } from '~src/workbook/models/IWorkbookInfo';
import { Workbooks } from '~src/workbook/resources/Workbooks';
import { IWorkbookActions } from '~src/workbook/ServerApi/types/IWorkbookActions';

import { getGenericDefaultFilters } from '../../../contentDefinitions/getDefaultFilters';


export const WorkbookDefinition: MixedContentItemDefinition & SpaceDefinition<'workbook'> = {
  itemType: 'workbook',
  contentType: 'workbook',
  singularName: Messages.workbook,
  pluralName: Messages.workbooks,
  emptyStateMessage: Messages.workbooksEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Workbooks,
  contentFilterKeys: WorkbookContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: WorkbookCard,
  listViewIconUrl: imgPath('workbook_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['workbook']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.workbookUrl(contentId),
  getBasicQuery: () => {
    return Workbooks.all().withExtraParams(WorkbookContentType.extraQueryParams);
  },
  fieldValueResourceType: 'workbook',
  getContentInfo: (contentList: IContentInfo[]) => call(getWorkbookInfos, contentList),
  headerIconPath: () => imgPath('spaces_masthead_workbook.svg'),
  supportedDisplayModes: ['list', 'thumbnail'],
  detailDialogTitle: Messages.workbookDetailsTitle,
  detailDialogBody: (content: IContentInfo<'workbook'>, availableActions: IWorkbookActions, contentLocation?: string) => {
    return (
        <ConnectedWorkbookDetailsDialogBody
        workbook={content as IWorkbookDetailInfoWithUsage}
        allowedActions={availableActions}
        location={contentLocation}
      />
    );
  },
};

